import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import { CUSTOM_TRACK_OPTICS_BREAKPOINT_DOWN_410 } from "../../helpers";

export default makeStyles((theme: MuiTheme) => {
  const {
    palette: { primary }
  } = theme;

  return {
    dialogHeader: {
      padding: 0,
      borderBottom: `1px solid ${primary.light}`,
      boxShadow: "0px 1px 7px 0px rgba(0, 0, 0, 0.15)",
      position: "relative",
      "& .MuiTypography-root": {
        height: 80,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        padding: 13,
        [CUSTOM_TRACK_OPTICS_BREAKPOINT_DOWN_410]: {
          height: 56,
          padding: "8px 16px",
          alignItems: "start"
        }
      }
    },
    dialogHeaderItem: {
      fontSize: 14,
      lineHeight: "normal",
      color: primary.main,
      textTransform: "capitalize",
      [CUSTOM_TRACK_OPTICS_BREAKPOINT_DOWN_410]: {
        fontSize: 12
      }
    },
    dialogTitle: {
      fontSize: 18,
      [CUSTOM_TRACK_OPTICS_BREAKPOINT_DOWN_410]: {
        fontSize: 16,
        lineHeight: "normal"
      }
    },
    dialogHeaderInfo: {
      color: "#2d2d2d",
      [CUSTOM_TRACK_OPTICS_BREAKPOINT_DOWN_410]: {
        color: primary.dark
      }
    },
    closeButton: {
      position: "absolute",
      right: 0,
      top: 0
    },
    closeButtonIcon: {
      fontSize: 30,
      color: primary.main
    },
    mobileVideoDetailsContent: {
      width: "100%",
      maxHeight: "none",
      height: "100%"
    },
    dialogContent: {
      padding: 0
    }
  };
});
